import { PromotionType } from "../../../../redux/type";
import { type CurrencyValueRow } from "../campaignForm";
import CurrencyValueList from "./CurrencyValueList";

interface RewardConfigCardProps {
  rows: CurrencyValueRow[];
  onChange: (rows: CurrencyValueRow[]) => void;
  campaignType: PromotionType;
}

export default function RewardConfigCard({
  rows,
  onChange,
  campaignType,
}: RewardConfigCardProps) {
  const valueLabel = campaignType.endsWith("_percent")
    ? "Reward Value (%)"
    : "Reward Value";

  return (
    <div className="bg-white border border-[#E4E4E7] rounded-[8px] p-[20px]">
      <p className="text-[16px] font-bold text-[#1E1E1E]">Reward Config</p>
      <p className="text-[13px] text-[#758089] mt-[2px]">
        Set the reward value for this campaign per currency
      </p>

      <div className="mt-[16px]">
        <CurrencyValueList
          rows={rows}
          onChange={onChange}
          valueLabel={valueLabel}
          valuePlaceholder="e.g. 10"
        />
      </div>
    </div>
  );
}
